// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radio-table {
  font-family: 'Roboto Condensed', sans-serif;
  margin-bottom: 20px;
  border-collapse: separate;
}
.radio-table thead {
  background-color: #a7e6d7;
  border-right-color: rgb(112 203 169);
  font-family: 'Work Sans', sans-serif;
  font-size: 12px;
}
.radio-table thead th {
  padding: 10px;
  border-right: 2px solid #97e1d0;
  border-bottom-color: #97e1d0;
}
.radio-table tbody tr td {
  padding: 10px;
  border-right: 2px solid #d8f2ec;
  border-top: 1px solid #d8f2ec;
  border-bottom: 1px solid #d8f2ec;
  font-size: 13px;
}
.radio-table tbody tr td.radio-td {
  border-right-color: #e7f7f3;
  border-top-color: #e7f7f3;
  border-bottom-color: #e7f7f3;
  background-color: #d8f2ec;
}
.radio-table tbody tr td.radio-td .radio-toggle {
  justify-content: center;
  width: 100%;
}
.radio-table tbody tr td.radio-td .radio-toggle .radio-outer {
  margin: 0;
}
.radio-table tbody tr td.label-td {
  border-right-color: #d8f2ec;
  border-top-color: #e7f7f3;
  border-bottom-color: #e7f7f3;
  background-color: #d8f2ec;
}
.radio-table tbody tr:first-child .radio-td,
.radio-table tbody tr:first-child .label-td,
.radio-table tbody tr:first-child td {
  border-top-color: #97e1d0;
}
.radio-table tbody tr:last-child td {
  border-bottom-width: 2px;
}
.radio-table tbody tr.selected {
  font-weight: 700;
  background-color: #f4f7f6;
}
.radio-table tbody tr.selected:first-child .radio-td,
.radio-table tbody tr.selected:first-child .label-td {
  border-top-color: #97e1d0;
}
.radio-table tbody tr.selected .radio-td,
.radio-table tbody tr.selected .label-td {
  background-color: #a7e6d7;
  border-top-color: #a7e6d7;
  border-bottom-color: #a7e6d7;
}
.radio-table tbody tr.selected .radio-td {
  border-right-color: #97e1d0;
}
.radio-table tbody tr.selected .label-td {
  border-right-color: #a7e6d7;
}
.radio-table tbody tr.selectable {
  cursor: pointer;
}
.radio-table th.pps-level-th {
  width: 85px;
}
.radio-table th.ambulation-th {
  width: 120px;
}
.radio-table th.activity-evidence-of-disease-th {
  width: 220px;
}
.radio-table th.self-care-th {
  width: 150px;
}
.radio-table th.intake-th {
  width: 110px;
}
.radio-table th.stage-th {
  width: 60px;
}
.radio-table th.clinical-diagnosis-th {
  width: 230px;
}
.radio-table th.duration-th {
  width: 100px;
}
`, "",{"version":3,"sources":["webpack://./../styleguide/src/components/RadioTable/main.less"],"names":[],"mappings":"AAEA;EACE,2CAAA;EACA,mBAAA;EACA,yBAAA;AADF;AAFA;EAMI,yBAAA;EACA,oCAAA;EACA,oCAAA;EACA,eAAA;AADJ;AARA;EAYM,aAAA;EACA,+BAAA;EACA,4BAAA;AADN;AAbA;EAoBQ,aAAA;EACA,+BAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;AAJR;AAMQ;EACE,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,yBAAA;AAJV;AAAQ;EAOI,uBAAA;EACA,WAAA;AAJZ;AAJQ;EAWM,SAAA;AAJd;AAQQ;EACE,2BAAA;EACA,yBAAA;EACA,4BAAA;EACA,yBAAA;AANV;AAUM;;;EAII,yBAAA;AATV;AAYM;EAEI,wBAAA;AAXV;AAeM;EACE,gBAAA;EACA,yBAAA;AAbR;AAeQ;;EAGI,yBAAA;AAdZ;AAOM;;EAaI,yBAAA;EACA,yBAAA;EACA,4BAAA;AAhBV;AACM;EAkBI,2BAAA;AAhBV;AAFM;EAqBI,2BAAA;AAhBV;AAoBM;EACE,eAAA;AAlBR;AA0BI;EACE,WAAA;AAxBN;AA0BI;EACE,YAAA;AAxBN;AA0BI;EACE,YAAA;AAxBN;AA0BI;EACE,YAAA;AAxBN;AA0BI;EACE,YAAA;AAxBN;AA4BI;EACE,WAAA;AA1BN;AA4BI;EACE,YAAA;AA1BN;AA4BI;EACE,YAAA;AA1BN","sourcesContent":["@import (reference) '~styleguide/src/styles/variables.less';\n\n.radio-table {\n  font-family: @font-family-roboto-condensed;\n  margin-bottom: 20px;\n  border-collapse: separate;\n\n  thead {\n    background-color: @mint;\n    border-right-color: @dark-mint;\n    font-family: @font-family-work-sans;\n    font-size: 12px;\n\n    th {\n      padding: 10px;\n      border-right: 2px solid @mint-darkened;\n      border-bottom-color: @mint-darkened;\n    }\n  }\n  tbody {\n    tr {\n      td {\n        padding: 10px;\n        border-right: 2px solid @lightMint;\n        border-top: 1px solid @lightMint;\n        border-bottom: 1px solid @lightMint;\n        font-size: 13px;\n\n        &.radio-td {\n          border-right-color: @lightMint-lightened;\n          border-top-color: @lightMint-lightened;\n          border-bottom-color: @lightMint-lightened;\n          background-color: @lightMint;\n\n          .radio-toggle {\n            justify-content: center;\n            width: 100%;\n\n            .radio-outer {\n              margin: 0;\n            }\n          }\n        }\n        &.label-td {\n          border-right-color: @lightMint;\n          border-top-color: @lightMint-lightened;\n          border-bottom-color: @lightMint-lightened;\n          background-color: @lightMint;\n        }\n      }\n\n      &:first-child {\n        .radio-td,\n        .label-td,\n        td {\n          border-top-color: @mint-darkened;\n        }\n      }\n      &:last-child {\n        td {\n          border-bottom-width: 2px;\n        }\n      }\n\n      &.selected {\n        font-weight: 700;\n        background-color: @bkgdBlue;\n\n        &:first-child {\n          .radio-td,\n          .label-td {\n            border-top-color: @mint-darkened;\n          }\n        }\n\n        .radio-td,\n        .label-td {\n          background-color: @mint;\n          border-top-color: @mint;\n          border-bottom-color: @mint;\n        }\n        .radio-td {\n          border-right-color: @mint-darkened;\n        }\n        .label-td {\n          border-right-color: @mint;\n        }\n      }\n\n      &.selectable {\n        cursor: pointer;\n      }\n    }\n  }\n\n  // TODO: these are customizations for FAST / PPS tables, eventually need customizations\n  th {\n    // PPS\n    &.pps-level-th {\n      width: 85px;\n    }\n    &.ambulation-th {\n      width: 120px;\n    }\n    &.activity-evidence-of-disease-th {\n      width: 220px;\n    }\n    &.self-care-th {\n      width: 150px;\n    }\n    &.intake-th {\n      width: 110px;\n    }\n\n    // FAST\n    &.stage-th {\n      width: 60px;\n    }\n    &.clinical-diagnosis-th {\n      width: 230px;\n    }\n    &.duration-th {\n      width: 100px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
